import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Celebrate',
  href: '#celebrate'
}, {
  name: 'Honor',
  href: '#honor'
}, {
  name: 'Support',
  href: '#support'
}, {
  name: 'Event',
  href: '#event'
}, {
  name: 'Flyer',
  href: '#flyer'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100" data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="flex justify-between items-center h-20" data-id="element-88">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-89">
            <a href="#" className="flex items-center gap-3" data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/4tAPPhhSxFFzHh1MdQYkPw/Good_Father_Project.png" alt="Good Father Project Logo" className="h-10 w-auto" data-id="element-91" />
              <span className="font-bold text-xl text-[#1a1a1a] hidden sm:block" data-id="element-92">
                Good Father Project
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-93">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-[#1e5631] font-medium transition-colors" data-id="element-94">
                {link.name}
              </a>)}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-95">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-[#1a1a1a] p-2" aria-label="Toggle menu" data-id="element-96">
              {isOpen ? <X size={24} data-id="element-97" /> : <Menu size={24} data-id="element-98" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 shadow-lg absolute w-full" data-id="element-99">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-100">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-[#1e5631] hover:bg-gray-50 rounded-md" onClick={() => setIsOpen(false)} data-id="element-101">
                {link.name}
              </a>)}
          </div>
        </div>}
    </nav>;
}